import axios from 'axios';

const TEN_MINUTES = 1000 * 60 * 10;
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api`,
  timeout: TEN_MINUTES,
});

export default api;
